export default "__VITE_ASSET__aa15ad58__"